import { useState } from 'react'
import { Props } from './Layout'
import {
  NftType,
  NotificationType,
  SortOrder,
  useNotificationsCountQuery,
  useNotificationsQuery,
} from './query.generated'

export const NOTIFICATION_PAGE_COUNT = 10

export type Params = {
  nftType: Array<NftType>
  notificationType: NotificationType
}

export const useProps = ({ nftType, notificationType }: Params): Props => {
  const [currentPage, setCurrentPage] = useState(1)

  const { data: countData } = useNotificationsCountQuery({
    variables: {
      where: { nftType: { in: nftType }, notificationType: { equals: notificationType } },
    },
  })

  const { data, refetch } = useNotificationsQuery({
    variables: {
      where: { nftType: { in: nftType }, notificationType: { equals: notificationType } },
      orderBy: { createdAt: SortOrder.Desc },
      skip: (currentPage - 1) * NOTIFICATION_PAGE_COUNT,
      take: NOTIFICATION_PAGE_COUNT,
    },
  })

  const allCount = countData?.currentUserNotificationsCount.count ?? 0
  const maxPage = Math.ceil(allCount / NOTIFICATION_PAGE_COUNT)

  return {
    notifications: data?.currentUserNotifications ?? [],
    paging: {
      allCount,
      maxPage,
      currentPage,
      onClickPage: (page: number) => {
        if (page < 0 || page > maxPage) return
        setCurrentPage(page)
        refetch()
      },
    },
  }
}
